/* Eagle collection page — filtering, sorting, load-more, and the mobile
   filter drawer. All grid updates go through the Section Rendering API
   (?section_id=...) with URL state kept in sync so results are shareable
   and the back button works. Loaded deferred by main-collection.liquid. */
(function () {
  'use strict';

  var root = document.querySelector('[data-collection-root]');
  if (!root) return;

  var sectionId = root.dataset.sectionId;
  var basePath = root.dataset.baseUrl;
  var productsRoot = root.querySelector('[data-products-root]');
  var sidebar = root.querySelector('[data-sidebar]');
  var backdrop = root.querySelector('[data-drawer-backdrop]');
  var form = root.querySelector('[data-filter-form]');
  var live = root.querySelector('[data-live]');
  var fetchId = 0;

  /* ---------- helpers ---------- */

  function announce(msg) {
    if (live) live.textContent = msg;
  }

  function currentSort() {
    var params = new URLSearchParams(window.location.search);
    var selected = root.querySelector('[data-sort-list] [aria-selected="true"]');
    return params.get('sort_by') || (selected ? selected.dataset.value : '');
  }

  function buildUrl(extra) {
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (value !== '' && key !== 'sort_by') params.append(key, value);
      });
    }
    var sort = (extra && extra.sort) || currentSort();
    if (sort) params.set('sort_by', sort);
    var qs = params.toString();
    return basePath + (qs ? '?' + qs : '');
  }

  function swapFromResponse(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-products-root]');
    if (next) productsRoot.innerHTML = next.innerHTML;
    var nextCount = doc.querySelector('[data-count]');
    var count = root.querySelector('[data-count]');
    if (nextCount && count) count.textContent = nextCount.textContent;
    var gridItems = productsRoot.querySelectorAll('[data-grid] > li').length;
    announce(gridItems === 0 ? 'No products match your filters' : gridItems + ' products shown');
  }

  function fetchAndSwap(url, push) {
    var id = ++fetchId;
    productsRoot.classList.add('is-loading');
    productsRoot.setAttribute('aria-busy', 'true');
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (id !== fetchId) return;
        swapFromResponse(html);
        if (push) history.pushState({ eagleCollection: true }, '', url);
      })
      .catch(function () {
        if (id === fetchId) window.location.href = url;
      })
      .finally(function () {
        if (id !== fetchId) return;
        productsRoot.classList.remove('is-loading');
        productsRoot.removeAttribute('aria-busy');
      });
  }

  /* ---------- filters ---------- */

  var priceTimer;
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      fetchAndSwap(buildUrl(), true);
    });
    form.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') fetchAndSwap(buildUrl(), true);
    });
    form.addEventListener('input', function (e) {
      if (e.target.type !== 'number') return;
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () {
        fetchAndSwap(buildUrl(), true);
      }, 500);
    });
  }

  function syncFormFromUrl() {
    if (!form) return;
    var params = new URLSearchParams(window.location.search);
    Array.prototype.forEach.call(form.elements, function (el) {
      if (el.type === 'checkbox') {
        el.checked = params.getAll(el.name).indexOf(el.value) !== -1;
      } else if (el.type === 'number') {
        el.value = params.get(el.name) || '';
      }
    });
  }

  /* chips, pagination links, empty-state clear — delegated */
  root.addEventListener('click', function (e) {
    var link = e.target.closest('[data-chip], [data-page-link]');
    if (!link || !root.contains(link)) return;
    e.preventDefault();
    var url = link.getAttribute('href');
    fetchAndSwap(url, true);
    if (link.hasAttribute('data-chip')) {
      // reflect removed filters back into the sidebar checkboxes
      history.replaceState(history.state, '', url);
      syncFormFromUrl();
    }
    if (link.hasAttribute('data-page-link')) {
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  /* ---------- load more ---------- */

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('href');
    btn.classList.add('is-loading');
    btn.textContent = 'Loading…';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'section_id=' + sectionId)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var target = productsRoot.querySelector('[data-grid-append]') ||
          productsRoot.querySelector('[data-grid]');
        var added = 0;
        doc.querySelectorAll('[data-grid] > li').forEach(function (li) {
          target.appendChild(li);
          added++;
        });
        var pagination = productsRoot.querySelector('[data-pagination]');
        var nextPagination = doc.querySelector('[data-pagination]');
        if (pagination && nextPagination) pagination.innerHTML = nextPagination.innerHTML;
        history.replaceState(history.state, '', url);
        announce(added + ' more products loaded');
      })
      .catch(function () {
        window.location.href = url;
      });
  });

  /* ---------- popstate (back/forward) ---------- */

  window.addEventListener('popstate', function () {
    syncFormFromUrl();
    fetchAndSwap(window.location.pathname + window.location.search, false);
  });

  /* ---------- sort dropdowns ---------- */

  root.querySelectorAll('[data-sort]').forEach(function (wrap) {
    var btn = wrap.querySelector('[data-sort-btn]');
    var list = wrap.querySelector('[data-sort-list]');
    if (!btn || !list) return;
    var options = Array.prototype.slice.call(list.querySelectorAll('[role="option"]'));

    function close() {
      list.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }
    function open() {
      list.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var current = list.querySelector('[aria-selected="true"]') || options[0];
      if (current) current.focus();
    }
    function select(option) {
      options.forEach(function (o) {
        o.setAttribute('aria-selected', o === option ? 'true' : 'false');
      });
      var label = root.querySelector('[data-sort-label]');
      if (label) label.textContent = option.textContent.trim();
      close();
      btn.focus();
      fetchAndSwap(buildUrl({ sort: option.dataset.value }), true);
    }

    btn.addEventListener('click', function () {
      if (list.classList.contains('is-open')) close();
      else open();
    });
    list.addEventListener('keydown', function (e) {
      var idx = options.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        (options[idx + 1] || options[0]).focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        (options[idx - 1] || options[options.length - 1]).focus();
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (idx > -1) select(options[idx]);
      } else if (e.key === 'Escape') {
        close();
        btn.focus();
      }
    });
    list.addEventListener('click', function (e) {
      var option = e.target.closest('[role="option"]');
      if (option) select(option);
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) close();
    });
  });

  /* ---------- mobile filter drawer ---------- */

  var lastFocused = null;

  function openDrawer() {
    if (!sidebar) return;
    lastFocused = document.activeElement;
    sidebar.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    root.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    var closeBtn = sidebar.querySelector('[data-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!sidebar) return;
    sidebar.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
    root.querySelectorAll('[data-drawer-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (lastFocused) lastFocused.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) openDrawer();
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
  });
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (!sidebar || !sidebar.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (e.key !== 'Tab') return;
    var focusables = sidebar.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'
    );
    if (focusables.length === 0) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();
